import React, { Component } from 'react';
// import { createMuiTheme } from '@material-ui/styles';
import LocationOn from '@material-ui/icons/LocationOn';
import AccessTime from '@material-ui/icons/AccessTime';
import Business from '@material-ui/icons/Business';
import Search from '@material-ui/icons/Search';
import Lock from '@material-ui/icons/Lock';
import MoneyOff from '@material-ui/icons/MoneyOff';
import DirectionsRun from '@material-ui/icons/DirectionsRun'
import Restaurant from '@material-ui/icons/Restaurant'
import LocalBar from '@material-ui/icons/LocalBar'
import Group from '@material-ui/icons/Group'
import ViewList from '@material-ui/icons/ViewList'

const mongo = process.env.REACT_APP_MONGO;
const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

export default class MobileLandingPage extends Component {

	constructor(){
		super()
		this.state={
			year: new Date().getFullYear()
		}
	}

	componentDidMount () {

	}

	render() {

		return (
			<div>
				<header>
					<div style={styles.videoWrapper}>

						<video style={styles.video} playsInline="playsinline" autoPlay="autoplay" muted="muted" loop="loop">
							<source src="https://firebasestorage.googleapis.com/v0/b/funily-deals.appspot.com/o/funilyWebsiteResources%2Fhead_video_v1.mov?alt=media&token=56000baa-f71a-42c5-8f7b-82d4699ddc4a" />
						</video>

					<img
						style={styles.imageHolder}
						src={require('../images/phoneimage.png')}
					/>

					</div>

					<div className="">

						<div
							className="d-flex h-100 text-center align-items-center"
							style={
								windowWidth > 1200 ?
									styles.description
								: styles.descriptionMedium
							}
						>
								<blockquote className="blockquote">
								  <p className="mb-0 lead">
									"This app is just what every family needs, ONE go-to spot for activities to do with our kids, restaurants, and parent's night out events listings."
									</p>
								  <footer className="blockquote-footer">Maria V., Aurora</footer>
								</blockquote>

								<blockquote className="blockquote">
								  <p className="mb-0 lead">
									"The Funily app is awesome!  Such a great idea to keep families informed on local events and things to do."
									</p>
								  <footer className="blockquote-footer">Casie B., Wheaton</footer>
								</blockquote>

								<blockquote className="blockquote">
								  <p className="mb-0 lead">
									"I would love to see this app take off!  It's so helpful to us moms."
									</p>
								  <footer className="blockquote-footer">Holly M., St. Charles</footer>
								</blockquote>
						</div>
					</div>
				</header>

			 	<div className='container-fluid col-md-12' style={styles.infoContainer}>

					<div className='col-md-6'>

						<div className='col-md' style={styles.productVideoWrapper}>
								<video style={styles.productVideo} playsInline="playsinline" autoPlay="autoplay" muted="muted" loop="loop">
									<source src="https://firebasestorage.googleapis.com/v0/b/funily-deals.appspot.com/o/funilyWebsiteResources%2FEventsDemo.MP4?alt=media&token=89492e8e-889e-4a97-a843-bacc1a170161" />
								</video>
						</div>
					</div>

					<div className='col-md-6' style={styles.categoryDescriptions}>
						<p className='h1 lead' style={styles.productDescription}>
							<strong>Play - </strong>Discover local kid-friendly events in your area; filter by location or date and save events that are important to you!
						</p>
						<p className='h1 lead' style={styles.productDescription}>
							<strong>Eat - </strong>Find local restaurants that offer weekly deals for families/kids and learn about unique events involving food.
						</p>
					</div>

				 </div>

				<div className='container col-md-12' style={styles.horizontalLine}>
				</div>

			 	<div className='container-fluid col-md-12' style={styles.infoContainer}>

					<div className='col-md-6'>
						<div className='col-md' style={styles.productVideoWrapper}>
								<video style={styles.productVideo} playsInline="playsinline" autoPlay="autoplay" muted="muted" loop="loop">
									<source src="https://firebasestorage.googleapis.com/v0/b/funily-deals.appspot.com/o/funilyWebsiteResources%2FfunilyCommunity.MP4?alt=media&token=a376b0cf-ac0c-4efb-8caf-50b06231e732" />
								</video>
						</div>
					</div>

				<div className='col-md-6' style={styles.categoryDescriptions}>
					<p className='h1 lead' style={styles.productDescription}>
						<strong>Parents' Night Out - </strong>Not sure what to do for that date night that ALL of us parents need?  Check out this section of the app for a variety of ideas!
					</p>
					<p className='h1 lead' style={styles.productDescription}>
						<strong>Community - </strong>Join our community and connect with other parents!  Be a part of a social forum where parents can learn and share information with each other on new events and activities.
					</p>
				</div>

				</div>

				<div className='col-md-12' style={styles.footer}>

					<p className='text-center'>FUNILY</p>
					<p className='text-center'>ALL RIGHTS RESERVED TO COMPANY {this.state.year}</p>

 				</div>

			</div>
		);
	}
}

const styles = {
	icon: {
		// height: theme.spacing.unit * 15,
		// width: theme.spacing.unit * 15,
		paddingBottom: 20,
		color: 'white'
	},
	videoWrapper: {
		// display: 'flex'
	},
	video: {
		objectFit: 'initial',
		height: "50vh",
		width: '100vw',
		top: 0,
		left: 0
	},
	imageHolder: {
		zIndex: 10,
		position: 'absolute',
		right: "5vw",
		top: "5vw",
		width: "25vw"
	},
	description: {
		width: '50vw',
		marginLeft: '15vw'
	},
	descriptionMedium: {
		width: '100vw',
		padding: '5vw',
	},
	bodyContainer: {
		display: 'flex',
		justifyContent: 'center'
	},
	allProductInfo: {
		width: '100vw'
	},
	bodyItem: {
		height: '50vh',
		padding: '5vw',

		// border: '1px solid grey'
	},
	infoContainer: {
		paddingTop: '5vw',
		paddingLeft: '5vw',
		paddingRight: '5vw'
	},
	h1: {
		color: 'white'
	},
	colWrapper: {
		// marginTop: '5vw'
	},
	productVideoWrapper: {
		position: 'relative',
		height: '500px',
		width: '275px',
		margin: '0 auto',
		boxShadow: '5px 5px 20px lightgrey'
	},
	productVideo: {
		objectFit: 'initial',
		alignSelf: 'center',
		position: 'absolute',
		top: 0,
		left: 0,
		width: "100%",
		height: '100%'
	},
	productDescription: {
		margin: '50px'
	},
	categoryDescriptions: {
		height: '550px',
		display:'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	},
	horizontalLine: {
		width: "50vw",
		marginLeft: '25vw',
		height: "0.25vh",
		backgroundColor: "#3748ac"
	},
	footer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent:'center',
		bottom: 0,
		width: '100vw',
		height: '10vh',
		marginTop: '10vw',
		backgroundColor: "#3748ac",
		color: 'white'
	},
	footerLeft: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around',
		alignItems: 'center'
	},
	footerRight: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	}

}



// WEBPACK FOOTER //
// ./src/components/mobileLandingPage.component.js